import Image from "next/image";
import { RecentPostCardProps } from "../types";
import { formatFullDate } from "@/components/koach/Shared/Helper";
import Link from "next/link";

const RecentPostCard = ({ baseUrl, guide }: RecentPostCardProps ): JSX.Element => {
  const addedOn = formatFullDate(guide?.attributes?.addedOn);
  return (
    <Link href={baseUrl + "/" + guide?.attributes?.slug}>
      <div className="group flex md:flex-col lg:flex-row cursor-pointer gap-1">
        <div className="relative relative w-[90px] h-[90px] group-hover:opacity-80">
          <Image
            src={guide?.attributes?.cover?.data?.attributes?.formats?.small?.url}
            alt={guide?.attributes?.title}
            priority
            layout="fill"
            objectFit="cover"
          />
        </div>
          
        <div className="flex-1 flex flex-col gap-2 px-3 md:px-0 lg:px-3 text-[14px]">
          <p>{guide?.attributes?.title}</p>
          <p className="text-grey-400 mt-auto">{addedOn}</p>
        </div>
      </div>
    </Link>
  );
};

export default RecentPostCard;
